/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class PriceIntervalVO extends JSONable {

  uuid: string | undefined = undefined;
  from: number | undefined = undefined;
  to: number | undefined = undefined;
  baseQuantity: number | undefined = undefined;
  basePrice: number | undefined = undefined;
  addQuantityStep: number | undefined = undefined;
  addPricePerStep: number | undefined = undefined;

}
